<template>
	<div class="header-logo" @click="onLogoClick">
		<app-icon name="logo" width="123px" height="24px" />
	</div>
</template>

<script setup lang="ts">
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import { useRoute, useRouter } from "vue-router"
import { chatsStore } from "@/store/chats"

const router = useRouter()
const route = useRoute()

const onLogoClick = () => {
	chatsStore().setMode('list')
	chatsStore().setOpenedChat(null)
	if (route.path === '/main' && route.query.page === 'chat' && route.query.mode === 'list') return
	router.push({
		path: '/main',
		query: {
			page: 'chat',
			mode: 'list'
		}
	})
}
</script>

<style scoped>
.header-logo {
	display: flex;
	align-items: center;
	cursor: pointer;
}
</style>
